var map = {
	"./adminprofile/edit": [
		2009,
		19
	],
	"./agentprofile/edit": [
		2010,
		22
	],
	"./ai_assistant/edit": [
		2011,
		25
	],
	"./api_key/edit": [
		2012,
		28
	],
	"./canned_answer/edit": [
		2013,
		33
	],
	"./chat_configuration/edit": [
		2014,
		6
	],
	"./client/edit": [
		2015,
		36
	],
	"./destination_restrictor/edit": [
		2016,
		38
	],
	"./disposition/edit": [
		2017,
		41
	],
	"./field/edit": [
		2018,
		44
	],
	"./form/edit": [
		2019,
		47
	],
	"./form_website/edit": [
		2020,
		50
	],
	"./gdpr/edit": [
		2021,
		52
	],
	"./invoice/edit": [
		2022,
		54
	],
	"./invoice_post/edit": [
		2023,
		57
	],
	"./journey/edit": [
		2024,
		60
	],
	"./journey_draft/edit": [
		2025,
		63
	],
	"./journey_variable/edit": [
		2026,
		67
	],
	"./list/edit": [
		2027,
		70
	],
	"./list_file/edit": [
		2028,
		73
	],
	"./mail_account/edit": [
		2029,
		76
	],
	"./operational_hours/edit": [
		2030,
		79
	],
	"./organization/edit": [
		2031,
		82
	],
	"./pause/edit": [
		2032,
		85
	],
	"./phonenumber_monthly_cost/edit": [
		2033,
		88
	],
	"./phonenumber_monthly_cost_parent/edit": [
		2034,
		91
	],
	"./phonenumber_purchase/edit": [
		2035,
		95
	],
	"./phonenumber_setup_cost/edit": [
		2036,
		98
	],
	"./phonenumber_setup_cost_parent/edit": [
		2037,
		101
	],
	"./points_system/edit": [
		2038,
		105
	],
	"./prepaid_credit/edit": [
		2039,
		108
	],
	"./queue/edit": [
		2040,
		111
	],
	"./signature/edit": [
		2041,
		115
	],
	"./skill/edit": [
		2042,
		118
	],
	"./sla_policy/edit": [
		2043,
		121
	],
	"./sound/edit": [
		2044,
		124
	],
	"./stats_alarm/edit": [
		2045,
		127
	],
	"./stats_custom_metric/edit": [
		2046,
		130
	],
	"./stats_report/edit": [
		2047,
		133
	],
	"./stats_widget/edit": [
		2048,
		136
	],
	"./superadmin_profile/edit": [
		2049,
		139
	],
	"./tag/edit": [
		2050,
		142
	],
	"./tariff/edit": [
		2051,
		145
	],
	"./tariff_parent/edit": [
		2052,
		148
	],
	"./team/edit": [
		2053,
		151
	],
	"./text_message_source/edit": [
		2054,
		9
	],
	"./time_interval/edit": [
		2055,
		155
	],
	"./user/edit": [
		2056,
		158
	],
	"./voice_asterisk/edit": [
		2057,
		161
	],
	"./voice_asterisk_downgrade/edit": [
		2058,
		164
	],
	"./voice_recording_transcript_setting/edit": [
		2059,
		168
	],
	"./voice_route/edit": [
		2060,
		171
	],
	"./voice_shortcut/edit": [
		2061,
		174
	],
	"./voice_trunk/edit": [
		2062,
		177
	],
	"./voice_voicemail/edit": [
		2063,
		180
	],
	"./wallboard/edit": [
		2064,
		183
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1879;
module.exports = webpackAsyncContext;